export default __webpack_public_path__ + "static/media/carousel-image2.png.webp";